/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'
import { OnChangeEventContext } from 'react-crane'

import { TermOption } from '../../../../../generated/graphql'
import { Select } from '../../../../shared/input'
import { hoverColor } from '../../../../../lib/styles/colors'
import { LabelVisibility } from '../../../../../types'
import useAppSettings from '../../../../../lib/hooks/useAppSettings'

type TermOptionsSelectProps = {
  /** Unique ID for the select field */
  id: string
  /** Event callback when an option */
  onChange: (e: OnChangeEventContext) => void
  /** List of term options to display in the dropdown */
  termOptions: Array<TermOption>
  /** Sequence of the term, e.g. Fall 1 or Fall 2, Term 1, etc. */
  termSequence: number
  /** Formatted value to display in the dropdown when it's closed  */
  title: string
}

const selectCss = css`
  height: 40px;
  margin-left: -5px;
  padding-bottom: 0;
  width: 130px;

  .crane-select {
    &:not(.open) .crane-select-input-group {
      border: none;
      background: none;
      cursor: pointer;
    }

    &.focus:not(.open) .crane-select-input-group {
      background: #ffffff;
    }

    &:hover:not(.open) .crane-select-input-group {
      background: ${hoverColor};
    }

    .crane-select-arrow-container {
      top: calc(50% - 7px);
    }
  }
`

const TermOptionsSelect = ({
  id,
  onChange,
  termOptions,
  termSequence,
  title
}: TermOptionsSelectProps) => {
  const valueRenderer = () => (
    <span>{`${title} ${termSequence && termSequence !== 0 ? termSequence : ''}`}</span>
  )
  const { text } = useAppSettings()
  const termLabel = text.term

  return (
    <Select
      css={selectCss}
      id={`${id}-${termLabel.toLowerCase()}-select`}
      label={`${termLabel} Type`}
      labelKey="value"
      labelVisibility={LabelVisibility.VISIBLE_ON_FOCUS}
      onChange={onChange}
      options={termOptions}
      valueKey="value"
      value={title}
      valueGroupRenderer={valueRenderer}
    />
  )
}

export default TermOptionsSelect
